import React, { Component } from 'react';
import $ from 'jquery';
import Waypoint from 'react-waypoint';
import smoothScroll from '../node_modules/smoothscroll/smoothscroll';
import { FormattedMessage } from 'react-intl';
import './App.css';

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      es: true
    }
  }
  enterHome() {
    $('nav li').css({
      background: 'transparent',
      border: '1px solid white'
    });
    $('#btn_home li').css('background', 'white');
  }
  enterLoquehacemos() {
    $('nav li').css({
      background: 'transparent',
      border: '1px solid white'
    });
    $('#btn_loquehacemos li').css('background', 'white');
  }
  enterEquipo() {
    $('nav li').css({
        background: 'transparent',
        border: '1px solid black'
      });
      $('#btn_equipo li').css('background', 'black');
  }
  enterContacto() {
    $('nav li').css({
      background: 'transparent',
      border: '1px solid black'
     });
     $('#btn_contacto li').css('background', 'black');
  }
  enviarForm() {
    event.preventDefault();
    var nombre = $('.nombre').val();
    var correo = $('.correo').val();
    var mensaje = $('.mensaje').val();
    var datos = 'nombre=' + nombre + '&correo=' + correo + '&mensaje=' + mensaje;
    $('.enviar').hide();
    $('.spiner').show();
    $.ajax({
        url:"enviar.php",
        type:'POST',
        data:datos,
        success:function() {
            $('.spiner').hide();
            $('.nombre').val('');
            $('.correo').val('');
            $('.mensaje').val('');
            $('.enviar').show();
        }
    })
  }
  translate = () => {
    this.setState({
      es: !this.state.es
    })
  }
  idioma = () => {
    if (this.state.es === false) {
      return (
        <div>
          <nav>
            <ul id="menu">
              <a id="btn_home" href='#home'><li className="btn-nav"></li></a>
              <a id="btn_loquehacemos" href='#loquehacemos'><li className="btn-nav"></li></a>
              <a id="btn_equipo" href='#Equipo'><li className="btn-nav"></li></a>
              <a id="btn_contacto" href='#Contacto'><li className="btn-nav"></li></a>
            </ul>
          </nav>
          <div className="section home" id='home' data-section-name="home">
            <a id='translateBtnEn' onClick={this.translate}>Español <span> / English</span></a>
            <figure>
              <img className="logo_home" src="./imgantilope/logo-antilope-a.png" alt="Antílope Interactive"/>
            </figure>
            <Waypoint onEnter={this.enterHome}
              onLeave={this.enterLoquehacemos}
             />
            <img className="home-scroll" src="imgantilope/arrow-scroll@3x.png"/>
          </div>
          <div className="section loquehacemos" id='loquehacemos'  data-section-name="loquehacemos">
            <div className="contenido_section2">
                <div className="titulo_section2">
                  <h2>
                    <FormattedMessage id='ENQuienesSomosTitle'/>
                  </h2>
                </div>
                <p className="parrafo_section2">
                  <FormattedMessage id='ENQuienesSomos'/>
                </p>
            </div>
             <div className="img_quehacemos">
              <div className="titulo_responsive">
                <h2><FormattedMessage id='ENQuienesSomosTitle'/></h2>
              </div>
              <img className="control-loquehacemos" src="imgantilope/logo-antilope-a.png" alt="AntilopeInteractive"/>
             </div>
          </div>
          <div className="section equipo" id='Equipo' data-section-name="equipo">
          <p style={{color:'white', opacity: 0, margin:0, padding:0}} className="controlequipo">Equipo</p>
            <div className="titulo_section3">
              <h2>
                <FormattedMessage id='ENEquipoTitle'/>
              </h2>
            </div>
            <Waypoint
              onEnter={this.enterEquipo}
              onLeave={this.enterLoquehacemos}
            />
            <div className="perfil-content">
              <figure>
                <img src="imgantilope/avatar_sebastian.jpg" alt="Sebastián Salazar Antílope Interactive"/>
              </figure>
              <section>
                <div className="perfil-descripcion">
                  <h4><FormattedMessage id='ENSebastianCargo'/></h4>
                  <h6>Sebastián Salazar</h6>
                </div>
                <div className="perfil-detalle">
                  <FormattedMessage id='ENSebastianText'/>
                </div>
              </section>
            </div>
            <div className="perfil-content">
              <figure>
                <img src="imgantilope/avatar_sebastian.jpg" alt="Orlando Valencia Antílope Interactive"/>
              </figure>
              <section>
                <div className="perfil-descripcion">
                  <h4><FormattedMessage id='ENOrlandoCargo'/></h4>
                  <h6>Orlando Valencia</h6>
                </div>
                <div className="perfil-detalle">
                  <FormattedMessage id='ENOrlandoText' />
                </div>
              </section>
            </div>
            <div className="perfil-content">
              <figure>
                <img src="imgantilope/avatar_sebastian.jpg" alt="Juan Camilo Valencia Antílope Interactive"/>
              </figure>
              <section>
                <div className="perfil-descripcion">
                  <h4>UI/UX - FRONTEND</h4>
                  <h6>Juan Camilo Valencia</h6>
                </div>
                <div className="perfil-detalle">
                  <FormattedMessage id='ENCamiloText' />
                </div>
              </section>
            </div>
            <div className="perfil-content">
              <figure>
                <img src="imgantilope/avatar_sebastian.jpg" alt="Ivan Gutiérrez Antílope Interactive"/>
              </figure>
              <section>
                <div className="perfil-descripcion">
                  <h4><FormattedMessage id='ENIvanCargo'/></h4>
                  <h6>Ivan Gutiérrez</h6>
                </div>
                <div className="perfil-detalle">
                  <FormattedMessage id='ENIvanText' />
                </div>
              </section>
            </div>
          </div>
          <div className="section contacto_S" id='Contacto' data-section-name="contacto">
          <p style={{color:'white', opacity: 0, margin:0, padding:0}}>Contacto</p>
            <div className="titulo_section4">
              <h2><FormattedMessage id='ENContactoTitle' /></h2>
            </div>
            <Waypoint
              onEnter={this.enterContacto}
            />
            <div className="contacto">
            <form action="enviar.php" method="post">
              <div className="contacto_input">
                <p><FormattedMessage id='ENContactoName' /></p>
                <input className="nombre" type="text" name="nombre"/>
              </div>
              <div className="contacto_input">
                <p><FormattedMessage id='ENContactoEmail' /></p>
                <input className="correo" type="email" name="correo"/>
              </div>
              <div className="contacto_input">
                <p><FormattedMessage id='ENContactoCuentanos' /></p>
                <textarea className="mensaje" name="mensaje" cols="30" rows="5"></textarea>
              </div>
              <div className="contacto_btn">
                <a className="enviar" onClick={this.enviarForm}><FormattedMessage id='ENContactoBtn' /></a>
                <img className="spiner" src="imgantilope/spiner.gif"/>
              </div>
              </form>
              <div className="contacto_tel">
                <p>TEL: (+57) 320 450 6969 / (+57) 319 617 2484</p>
                <p>Colombia</p>
              </div>
              <a href="#home" className="img_contacto"><img className="img_contacto" src="imgantilope/logo-antilope-b-01.png" alt="AntilopeInteractive"/></a>
            </div>
          </div>
        </div>
      )
    }
    else {
      return (<div>
        <nav>
          <ul id="menu">
            <a id="btn_home" href='#home'><li className="btn-nav"></li></a>
            <a id="btn_loquehacemos" href='#loquehacemos'><li className="btn-nav"></li></a>
            <a id="btn_equipo" href='#Equipo'><li className="btn-nav"></li></a>
            <a id="btn_contacto" href='#Contacto'><li className="btn-nav"></li></a>
          </ul>
        </nav>
        <div className="section home" id='home' data-section-name="home">
          <a id='translateBtn' onClick={this.translate}>Español <span> / English</span></a>
          <figure>
            <img className="logo_home" src="./imgantilope/logo-antilope-a.png" alt="Antílope Interactive"/>
          </figure>
          <Waypoint onEnter={this.enterHome}
            onLeave={this.enterLoquehacemos}
           />
          <img className="home-scroll" src="imgantilope/arrow-scroll@3x.png"/>
        </div>
        <div className="section loquehacemos" id='loquehacemos'  data-section-name="loquehacemos">
          <div className="contenido_section2">
              <div className="titulo_section2">
                <h2>
                  <FormattedMessage id='QuienesSomosTitle'/>
                </h2>
              </div>
              <p className="parrafo_section2">
                <FormattedMessage id='QuienesSomos'/>
              </p>
          </div>
           <div className="img_quehacemos">
            <div className="titulo_responsive">
              <h2><FormattedMessage id='QuienesSomosTitle'/></h2>
            </div>
            <img className="control-loquehacemos" src="imgantilope/logo-antilope-a.png" alt="AntilopeInteractive"/>
           </div>
        </div>
        <div className="section equipo" id='Equipo' data-section-name="equipo">
        <p style={{color:'white', opacity: 0, margin:0, padding:0}} className="controlequipo">Equipo</p>
          <div className="titulo_section3">
            <h2>
              <FormattedMessage id='EquipoTitle'/>
            </h2>
          </div>
          <Waypoint
            onEnter={this.enterEquipo}
            onLeave={this.enterLoquehacemos}
          />
          <div className="perfil-content">
            <figure>
              <img src="imgantilope/avatar_sebastian.jpg" alt="Sebastián Salazar Antílope Interactive"/>
            </figure>
            <section>
              <div className="perfil-descripcion">
                <h4><FormattedMessage id='SebastianCargo'/></h4>
                <h6>Sebastián Salazar</h6>
              </div>
              <div className="perfil-detalle">
                <FormattedMessage id='SebastianText'/>
              </div>
            </section>
          </div>
          <div className="perfil-content">
            <figure>
              <img src="imgantilope/avatar_sebastian.jpg" alt="Orlando Valencia Antílope Interactive"/>
            </figure>
            <section>
              <div className="perfil-descripcion">
                <h4><FormattedMessage id='OrlandoCargo'/></h4>
                <h6>Orlando Valencia</h6>
              </div>
              <div className="perfil-detalle">
                <FormattedMessage id='OrlandoText' />
              </div>
            </section>
          </div>
          <div className="perfil-content">
            <figure>
              <img src="imgantilope/avatar_sebastian.jpg" alt="Juan Camilo Valencia Antílope Interactive"/>
            </figure>
            <section>
              <div className="perfil-descripcion">
                <h4>UI/UX - FRONTEND</h4>
                <h6>Juan Camilo Valencia</h6>
              </div>
              <div className="perfil-detalle">
                <FormattedMessage id='CamiloText' />
              </div>
            </section>
          </div>
          <div className="perfil-content">
            <figure>
              <img src="imgantilope/avatar_sebastian.jpg" alt="Ivan Gutiérrez Antílope Interactive"/>
            </figure>
            <section>
              <div className="perfil-descripcion">
                <h4><FormattedMessage id='IvanCargo'/></h4>
                <h6>Ivan Gutiérrez</h6>
              </div>
              <div className="perfil-detalle">
                <FormattedMessage id='IvanText' />
              </div>
            </section>
          </div>
        </div>
        <div className="section contacto_S" id='Contacto' data-section-name="contacto">
        <p style={{color:'white', opacity: 0, margin:0, padding:0}}>Contacto</p>
          <div className="titulo_section4">
            <h2><FormattedMessage id='ContactoTitle' /></h2>
          </div>
          <Waypoint
            onEnter={this.enterContacto}
          />
          <div className="contacto">
          <form action="enviar.php" method="post">
            <div className="contacto_input">
              <p><FormattedMessage id='ContactoName' /></p>
              <input className="nombre" type="text" name="nombre"/>
            </div>
            <div className="contacto_input">
              <p><FormattedMessage id='ContactoEmail' /></p>
              <input className="correo" type="email" name="correo"/>
            </div>
            <div className="contacto_input">
              <p><FormattedMessage id='ContactoCuentanos' /></p>
              <textarea className="mensaje" name="mensaje" cols="30" rows="5"></textarea>
            </div>
            <div className="contacto_btn">
              <a className="enviar" onClick={this.enviarForm}><FormattedMessage id='ContactoBtn' /></a>
              <img className="spiner" src="imgantilope/spiner.gif"/>
            </div>
            </form>
            <div className="contacto_tel">
              <p>TEL: (+57) 320 450 6969 / (+57) 319 617 2484</p>
              <p>Colombia</p>
            </div>
            <a href="#home" className="img_contacto"><img className="img_contacto" src="imgantilope/logo-antilope-b-01.png" alt="AntilopeInteractive"/></a>
          </div>
        </div>
      </div>)
    }
  }
  render() {
    return (
      <div>

        {
          this.idioma()
        }
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js